<template>
  <div class="water">
    <div class="returnScence" @click="returnScence"></div>
    <!-- <div
      class="returnScence2"
      @click="returnScence2"
      v-show="isShowParkingNormal"
    ></div> -->
    <div class="left-water-content">
      <div class="top-water">
        <custom-dayPlane
          :title="`水能耗(${areaNum2[areaNum]})`"
          :iconImg="require('@/assets/consump/water.png')"
          @changeDay="changeDay"
        >
          <div class="water-content">
            <div class="left-content">
              <div class="top-num">
                <div class="num">{{ getTimeValue(getWaterAreaNum) }}</div>
              </div>
              <div class="bot-name">{{ map[timeValue] }}总量(m³)</div>
            </div>
            <div class="right-chart">
              <custom-charts
                :dataList="dataList"
                :timer="timeValue"
              ></custom-charts>
            </div>
          </div>
        </custom-dayPlane>
      </div>
      <div class="bot-water">
        <!-- {{tableData}} -->
        <custom-table
          :areaNum="areaNum"
          :header="header"
          :isLoadEnd="isLoadEnd"
          :tableData="tableData"
          ref="waterCons"
        ></custom-table>
      </div>
    </div>
    <div class="right-content">
      <water-meter
        ref="childWater"
        :meterData="meterData"
        @foo="closeDialog"
        v-if="isWaterMeter"
      ></water-meter>
    </div>
  </div>
</template>

<script>
import bus from "@/components/three-scene/Bus.js";
import waterCons from "../../components/water-cons.vue";
import {
  getWaterEnergyData,
  getEqpInfo,
  getWaterEnergyDataByArea,
} from "@/api/index.js";
import WaterMeter from "./components/water-meter.vue";
export default {
  components: { waterCons, WaterMeter },
  data() {
    return {
      timer: null,
      isShowDialog: false,
      isShowParkingNormal: false,
      isLoadEnd: false,
      isShowReturn: false,
      areaNum: "总",
      areaNum2: {
        A区地下室: "A",
        B区地下室: "B",
        C区地下室: "C",
        D区地下室: "D",
        人防区地下室: "人防",
        总: "总",
        A1: "A1",
        A2: "A2",
        B1B2: "B1B2",
        B3: "B3",
      },
      waterData: {},
      meterData: {},
      header: [
        {
          name: "区号",
          key: "buildNo",
          width: "48",
        },
        {
          name: "楼层",
          key: "floor",
          width: "40",
          flag: 0,
        },
        {
          name: "设备名",
          key: "eqpName",
          width: "100",
          flag: 0,
        },
        {
          name: "日能耗",
          unit: "(m³)",
          key: "energyDay",
          width: "94",
          isUp: 0,
          flag: 1,
        },
        {
          name: "月能耗",
          unit: "(m³)",
          key: "energyMonth",
          width: "94",
          isUp: 0,
          flag: 1,
        },
      ],
      WaterAreaData: {},
      isWaterMeter: false,
      tableData: [],
      timeValue: "day",
      map: {
        day: "当日",
        month: "当月",
        year: "当年",
      },
      buildMap: {
        总: "total",
        B3: "04",
        B1B2: "03",
        A2: "02",
        A1: "01",
        A区地下室: "A",
        B区地下室: "B",
        C区地下室: "C",
        D区地下室: "D",
        人防区地下室: "人防",
      },
      dayMap: {
        day: "historicalDay",
        month: "historicalMonth",
        year: "historicalYear",
      },
      indexMap: {
        day: [10, 13],
        month: [8, 11],
        year: [5, 8],
      },
    };
  },
  watch: {
    WaterAreaData() {
      this.$nextTick(() => {
        if (this.$refs.childWater) {
          this.$refs.childWater.dataBtn = "用水量";
        }
      });
    },
  },
  mounted() {
    this.$store.state.threeEvent.intoWaterCon = true;
    bus.on("setName", this.getBuild);
    bus.emit("openFloorLabel", true);
    bus.emit("showFloorPoint", "水表", true);
    bus.on("dialogNumber", this.showDialogContainer);
    bus.on("parkingArea2", this.clickParking);
  },
  computed: {
    getWaterAreaNum() {
      if (this.WaterAreaData[this.buildMap[this.areaNum]]) {
        return this.WaterAreaData[this.buildMap[this.areaNum]][this.timeValue];
      }
    },
    dataList() {
      let selectBuid = this.buildMap[this.areaNum];
      let selectDay = this.dayMap[this.timeValue];
      if (this.WaterAreaData?.[selectBuid]?.[selectDay]) {
        return this.loadData(
          this.WaterAreaData[this.buildMap[this.areaNum]][
            this.dayMap[this.timeValue]
          ],
          this.indexMap[this.timeValue][0],
          this.indexMap[this.timeValue][1]
        );
      }
      return { x: [], y: [] };
    },
  },
  created() {
    this.getEnergyWater();
    this.getWaterEnergyDataByArea();
    this.timer = setInterval(() => {
      // this.getEnergyWater();
      this.getWaterEnergyDataByArea();
    }, 30*60*1000);
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    clickParking() {
      this.isShowParkingNormal = true;
    },
    returnScence2() {
      bus.emit("parking-mr");
      this.isShowParkingNormal = false;
      if (this.isShowDialog) {
        this.closeDialog();
      }
    },
    async showDialogContainer(eqpCode) {
      let { data: res } = await getEqpInfo({ eqpCode });
      this.meterData = res;
      this.isWaterMeter = true;
      this.isShowDialog = true;
    },
    getBuild(buildName) {
      this.areaNum = buildName;
      this.isShowReturn = true;
    },
    returnScence() {
      bus.emit("back");
      this.areaNum = "总";
      this.$refs.waterCons.selectIndex = null;
      if (this.isShowDialog) {
        this.closeDialog();
      }
    },
    getTimeValue(value) {
      if (!value && value != 0) {
        value = "-";
      }
      return value;
    },
    async getEnergyWater() {
      let { data: res } = await getWaterEnergyData();
      // this.eleData = res.electricity;
      this.tableData = res;
      this.isLoadEnd = true;
    },
    async getWaterEnergyDataByArea() {
      let { data: res } = await getWaterEnergyDataByArea();
      this.WaterAreaData = res;
    },
    loadData(value, first, end) {
      let resData = { x: [], y: [] };
      value.map((item, index) => {
        let [res] = Object.entries(item);
        resData.x.push(res[0].slice(first, end));
        resData.y.push(res[1]);
      });
      return resData;
    },
    changeDay(value) {
      this.timeValue = value;
      if (this.timeValue == "day") {
        this.loadData(
          this.WaterAreaData[this.buildMap[this.areaNum]].historicalDay,
          10,
          13
        );
      } else if (this.timeValue == "month") {
        this.loadData(
          this.WaterAreaData[this.buildMap[this.areaNum]].historicalMonth,
          8,
          11
        );
      } else {
        this.loadData(
          this.WaterAreaData[this.buildMap[this.areaNum]].historicalYear,
          5,
          8
        );
      }
    },
    // 关闭弹框
    closeDialog() {
      this.isShowDialog = false;
      this.isWaterMeter = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.returnScence {
  position: absolute;
  width: 144px;
  height: 56px;
  left: 536px;
  top: 135px;
  cursor: pointer;
  background-image: url("../../../../../../assets/pagesImg/returnBtn-normal.png");
  &:hover {
    background-image: url("../../../../../../assets/pagesImg/returnBtn-active.png");
  }
}
.returnScence2 {
  position: absolute;
  width: 144px;
  height: 56px;
  left: 536px;
  top: 213px;
  cursor: pointer;
  background-image: url("../../../../../../assets/pagesImg/returnBtn-normal.png");

  &:hover {
    background-image: url("../../../../../../assets/pagesImg/returnBtn-active.png");
  }
}
.left-water-content {
  position: absolute;
  left: 107px;
  top: 135px;
  width: 416px;
  .top-water {
    width: 100%;
    height: 178px;
    .water-content {
      position: relative;
      display: flex;
      margin: 20px;
      .left-content {
        width: 156px;
        height: 92px;
        .top-num {
          display: flex;
          width: 156px;
          height: 55px;
          align-items: baseline;
          .num {
            font-weight: 500;
            font-size: 48px;
            line-height: 55px;
            // width: 74px;
            color: #2d82ff;
            font-family: "dina";
          }
          .unit {
            // position: absolute;
            // top: -47px;
            // left: 113px;
            margin-left: 4px;
            font-weight: 500;
            font-size: 20px;
            line-height: 23px;
            color: rgba(255, 255, 255, 0.8);
            font-family: "dina";
          }
        }
        .bot-name {
          margin-top: 10px;
          font-weight: 500;
          font-size: 18px;
          line-height: 27px;
          color: #fff;
        }
      }
      .right-chart {
        margin-left: 20px;
        width: 200px;
        height: 91px;
      }
    }
  }
  .bot-water {
    height: 678px;
    margin-top: 20px;
  }
}
.right-content {
  position: absolute;
  top: 135px;
  right: 43px;
  width: 416px;
  height: 272px;
}
</style>
